import { render, staticRenderFns } from "./addGroupAlarm.vue?vue&type=template&id=dc385d74&scoped=true"
import script from "./addGroupAlarm.vue?vue&type=script&lang=js"
export * from "./addGroupAlarm.vue?vue&type=script&lang=js"
import style0 from "./addGroupAlarm.vue?vue&type=style&index=0&id=dc385d74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc385d74",
  null
  
)

export default component.exports